/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CaseListItemDto } from '../model/caseListItemDto';
import { ResellerCaseListItemDto } from '../model/resellerCaseListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CaseListingService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param showOnlyStock 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getList(showOnlyStock?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<CaseListItemDto>>;
    public getList(showOnlyStock?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CaseListItemDto>>>;
    public getList(showOnlyStock?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CaseListItemDto>>>;
    public getList(showOnlyStock?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (showOnlyStock !== undefined && showOnlyStock !== null) {
          queryParameters = queryParameters.set('showOnlyStock', <any>showOnlyStock);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CaseListItemDto>>(`${this.basePath}/api/CaseListing/List`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param branchUrlPart 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getResellerList(branchUrlPart: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ResellerCaseListItemDto>>;
    public getResellerList(branchUrlPart: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ResellerCaseListItemDto>>>;
    public getResellerList(branchUrlPart: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ResellerCaseListItemDto>>>;
    public getResellerList(branchUrlPart: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (branchUrlPart === null || branchUrlPart === undefined) {
            throw new Error('Required parameter branchUrlPart was null or undefined when calling getResellerList.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ResellerCaseListItemDto>>(`${this.basePath}/api/CaseListing/${encodeURIComponent(String(branchUrlPart))}/Reseller/List`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
